export default "__VITE_ASSET__CvTTsW2R__"